import React from 'react';

const Setting = () => {
    return (
        <div>
            this is Setting
        </div>
    );
};

export default Setting;